var map = {
	"./01_icon.svg": 29414,
	"./DocoMatic beta logo.svg": 80085,
	"./DocoMatic_beta.svg": 95638,
	"./DocoMatic_logo.svg": 53858,
	"./accordion-arrow.svg": 98749,
	"./action.svg": 53271,
	"./active-tag-cross.svg": 78430,
	"./active_icon.svg": 81374,
	"./add-circle.svg": 32149,
	"./apple-icon-180x180.png": 56440,
	"./archiveicn.svg": 73374,
	"./arrow-down.svg": 1313,
	"./arrow-radio.svg": 77556,
	"./arrow-right.svg": 15327,
	"./arrow-square-left.svg": 73913,
	"./arrow-up.svg": 65277,
	"./arrow.svg": 48813,
	"./beta_logo.svg": 40453,
	"./blanksickediti.svg": 33147,
	"./brand_logo.svg": 36870,
	"./chart.png": 64772,
	"./chat-doc.svg": 68846,
	"./chat-logo.svg": 66277,
	"./chat-send-icon.svg": 17378,
	"./chat-slide-arrow.svg": 82901,
	"./chatbot_icon.svg": 73116,
	"./chatbot_logo.svg": 45987,
	"./check.png": 18840,
	"./check_icn.svg": 98194,
	"./checkfl.svg": 15051,
	"./close-arrow.svg": 79360,
	"./close-circle.svg": 3389,
	"./close-setting.svg": 9241,
	"./code_icon.svg": 37889,
	"./confirmation-icon.svg": 41889,
	"./copy-icon.svg": 80281,
	"./cross_icn.svg": 99466,
	"./csv-icon.svg": 34131,
	"./csv.svg": 4872,
	"./dashicn.svg": 42886,
	"./date-checked.svg": 97222,
	"./dislike-chat.svg": 15208,
	"./doc-icon.svg": 41436,
	"./doc_icn.svg": 43121,
	"./docicn.svg": 13315,
	"./docs.svg": 66500,
	"./document-text.svg": 47887,
	"./docuploadicn.svg": 37500,
	"./download.svg": 23694,
	"./dropdown-arrow.svg": 35187,
	"./edit.svg": 76937,
	"./edit_project.svg": 13582,
	"./ej_img.svg": 25445,
	"./element_plus.svg": 50976,
	"./epub-icon.svg": 66126,
	"./export.svg": 66379,
	"./exportpficn.svg": 48278,
	"./eyeicn.svg": 68692,
	"./eyelineicn.svg": 65075,
	"./fav-star.svg": 86472,
	"./favicon-16x16.png": 32897,
	"./favicon-32x32.png": 89900,
	"./fileicn.svg": 82867,
	"./filessearch.svg": 94228,
	"./filtericn.svg": 99212,
	"./flags16.png": 93431,
	"./header_logo.png": 38369,
	"./help.svg": 62909,
	"./help_butt.svg": 58244,
	"./html-icon.svg": 18135,
	"./html_icn.svg": 18960,
	"./icn_chat.svg": 95160,
	"./icn_delete.svg": 31291,
	"./icn_delete_filter.svg": 22356,
	"./icn_done.svg": 52232,
	"./icn_edit.svg": 61160,
	"./icn_filter.svg": 67223,
	"./icn_like_active.svg": 34281,
	"./icn_tones.svg": 79542,
	"./icon.svg": 65500,
	"./info.svg": 41710,
	"./infoicn.svg": 52215,
	"./json-icon.svg": 63377,
	"./leftarroicn.svg": 40230,
	"./like-active.svg": 74473,
	"./like-chat.svg": 35002,
	"./link-square.svg": 31004,
	"./link_copy.svg": 63786,
	"./loader-shadow.png": 74872,
	"./logo.svg": 82835,
	"./logout.svg": 16301,
	"./logoutNEW.svg": 13512,
	"./lxml-icon.svg": 24045,
	"./md-icon.svg": 25817,
	"./minus-circle.svg": 51251,
	"./moredown-icn.svg": 79020,
	"./music-icon.svg": 11536,
	"./new-dislike.svg": 5386,
	"./new-like.svg": 64578,
	"./new_icn_chat.svg": 42140,
	"./newlogoicn.svg": 71724,
	"./noteicn.svg": 59844,
	"./notification.svg": 95105,
	"./notify_icn.svg": 58242,
	"./notsync_icn.svg": 21349,
	"./odt-icon.svg": 72236,
	"./pdf-icon.svg": 78302,
	"./pdf.svg": 76753,
	"./pdf_icn.svg": 34524,
	"./pdficn.svg": 20636,
	"./persona-icon.svg": 96860,
	"./pgn-left.svg": 63516,
	"./pgn-right.svg": 6855,
	"./plus-btn-lg.svg": 96395,
	"./plusbtnicn.svg": 40854,
	"./plusicn.svg": 68689,
	"./ppt-icon.svg": 28143,
	"./ppt.svg": 8682,
	"./printer.svg": 5775,
	"./profile_2user.svg": 81550,
	"./redirect.svg": 97869,
	"./remove-labl-icn.svg": 7480,
	"./rename.svg": 10254,
	"./reset.svg": 98658,
	"./resync.svg": 59207,
	"./rft-icon.svg": 30185,
	"./rss-icon.svg": 14723,
	"./rtf-icon.svg": 93048,
	"./save.svg": 37181,
	"./search-country.svg": 44904,
	"./search-filter.png": 98706,
	"./search.svg": 73794,
	"./select-arrow.svg": 72369,
	"./send-chat.svg": 637,
	"./setting-2.svg": 27180,
	"./setting-chat.svg": 63772,
	"./settings.svg": 45812,
	"./share.svg": 64459,
	"./shareadduser.svg": 90839,
	"./sickeditorimg.svg": 91450,
	"./sidebarHeader.svg": 42152,
	"./spiderimg.svg": 68653,
	"./spiderimg_active.svg": 77628,
	"./star.svg": 83111,
	"./status-sync.svg": 14220,
	"./status_up.svg": 25378,
	"./switch-arrow.svg": 36150,
	"./switch_proje.svg": 59070,
	"./syncprogress_icn.svg": 70884,
	"./syncwith_progress.svg": 51130,
	"./table_dwicn.svg": 30268,
	"./tag-cross-fill.svg": 1689,
	"./tag-cross.svg": 11448,
	"./text-ticon.svg": 60591,
	"./text_icn.svg": 23947,
	"./textlogo.svg": 15642,
	"./textlogo_bet.svg": 88278,
	"./toggle_icn.svg": 87284,
	"./trash-chat.svg": 59861,
	"./trash.svg": 11149,
	"./trashicn.svg": 48969,
	"./txt-icon.svg": 65984,
	"./unsync.svg": 43424,
	"./unsync_icn.svg": 4341,
	"./uparrowicn.svg": 49835,
	"./upload-icon.svg": 60263,
	"./user.svg": 13816,
	"./userpf.svg": 43924,
	"./view_summary.svg": 39436,
	"./web-crawler-active.svg": 26960,
	"./web-crawler.svg": 25753,
	"./web-icon.svg": 54135,
	"./writei_icn.svg": 13684,
	"./xls-icon.svg": 37128,
	"./xml-icon.svg": 95940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78913;